import { isStepSkeleton } from "../core/utils";
import { classifyCanvasNode, isBackingEntityKind, isEventNodeKind } from "../core/nodeKind";
/**
 * Stamps the editor-only node state: mode, the `isSelected: false` seed the
 * selection overlay compares against, skeleton/orphan, issue markers and
 * clickability.
 */ export function decorateEditorNode(node, ctx, markers) {
    const stepRec = node.data?.stepRecording;
    const kind = classifyCanvasNode(node);
    // `deletable: false` on synthetic nodes (start/end/lanes/viral
    // placeholders) stops RF from removing them from local state on
    // Backspace/Delete — otherwise they flicker out and back in once the
    // structural rebuild restores them.
    const isBackingEntity = isBackingEntityKind(kind);
    const isEventNode = isEventNodeKind(kind);
    const isGatewayNode = kind === "decision" || kind === "synthetic-gateway";
    // Only the activity card and the gateway diamond render an overlay; every
    // other node kind ignores the fields, so don't stamp them.
    const supportsOverlay = kind === "step" || isGatewayNode;
    const overlay = markers.overlayMap?.get(node.id);
    return {
        ...node,
        data: {
            ...node.data,
            mode: "edit",
            isSelected: false,
            ...isBackingEntity ? {
                hasPublishError: markers.errorNodeIds?.has(node.id) ?? false
            } : {},
            ...stepRec ? {
                isSkeleton: isStepSkeleton(stepRec),
                isOrphaned: !ctx.incomingEdgeTargets.has(node.id)
            } : {},
            ...isEventNode ? {
                isClickable: markers.hasDetailRenderer,
                isDisconnected: markers.disconnectedEventIds?.has(node.id) ?? false
            } : {},
            ...isGatewayNode ? {
                incompleteRuleIds: markers.incompleteRuleIdsByStep?.get(node.id)
            } : {},
            ...supportsOverlay ? {
                overlayColor: overlay?.color,
                overlayLabel: overlay?.label,
                overlayBadges: overlay?.badges
            } : {}
        },
        draggable: kind !== "swimlane",
        deletable: isBackingEntity
    };
}

//# sourceMappingURL=decorateEditorNode.js.map